// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Login/17973908.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login{
    border: 2px solid #00000017;
    padding: 15px;
    border-radius: 5px;
    margin-top: 9rem;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    opacity: 1.9;
 
}
.loginInput{
    margin-top: 35px;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 5px;
    height: 50px;
    width: 100%;
}

.LoginRow{
    display: flex;
    justify-content: center;
  
}
.LoginImg {
    height: 100vh;
    overflow: hidden;
  }
  .LoginImg::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(180deg); /* Rotate the pseudo-element (background image) by 180 degrees */
  }
.LoginButton{
    border-radius: 6px;
    width: 85px;
    font-weight: 500;
    float: right;
    margin-bottom: 25px;
    height: 35px;
}

.signUpButton{
    background: #FFFFFF;
    margin-left: 50px;
    margin-right: 50px;
    height: 42px;
    border-radius: 6px;
    width: 300px;
font-weight: 500;
margin-bottom: 20px;

}

.LoginH1{
    text-align: center;
    margin: 25px 0px 50px 0px;
    font-weight: 500;
} 
.forgotpassword{
    float: left;
    margin-top: 5px;
    
}
.ortag{
    color: #D2D2D2;
    margin-left: 139px;
    margin-bottom: 30px;
    /* margin-top: 80px; */

 }
.SubmitButton{
    margin-Top: 50px;
    margin-right: 58px;
}
.loginImage {
    width: auto;
    height: 62px;
}
.LogoDiv{
    display: flex;
    justify-content: center;
}
.otpInput{
    margin-top: 30px;
}
.logindiv1{
    margin: 0 auto;
    margin-top: 30vh;
}
.otpInput .otpBoxInput input{
    width: 50px !important;
    height: 50px;
    font-size: 20px;
    border-radius: 8px;
    border: 1px solid #CDCDCD;
    margin-right: 10px;
    
    
}
.otpInput{
    width: 200px !important;
}
.otpInput .otpBoxInput input:first-child {
    margin-left: 20px; /* Adjust the value as needed */
}

.otpInput .otpBoxInput input:last-child {
    margin-right: 0;
}
.ForgotpassRow{
    justify-content: center;
}
.Btncls{
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mCAA2B;YAA3B,2BAA2B;IAC3B,YAAY;;AAEhB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;;AAE3B;AACA;IACI,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAmD;IACnD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB,EAAE,gEAAgE;EAC7F;AACF;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB,gBAAgB;AAChB,mBAAmB;;AAEnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;;AAEnB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;CAEzB;AACD;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;;;AAGtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB,EAAE,+BAA+B;AACtD;;AAEA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".Login{\n    border: 2px solid #00000017;\n    padding: 15px;\n    border-radius: 5px;\n    margin-top: 9rem;\n    backdrop-filter: blur(20px);\n    opacity: 1.9;\n \n}\n.loginInput{\n    margin-top: 35px;\n    background: #FFFFFF;\n    border: 1px solid #CDCDCD;\n    border-radius: 5px;\n    height: 50px;\n    width: 100%;\n}\n\n.LoginRow{\n    display: flex;\n    justify-content: center;\n  \n}\n.LoginImg {\n    height: 100vh;\n    overflow: hidden;\n  }\n  .LoginImg::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('/public/Login/17973908.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    transform: rotate(180deg); /* Rotate the pseudo-element (background image) by 180 degrees */\n  }\n.LoginButton{\n    border-radius: 6px;\n    width: 85px;\n    font-weight: 500;\n    float: right;\n    margin-bottom: 25px;\n    height: 35px;\n}\n\n.signUpButton{\n    background: #FFFFFF;\n    margin-left: 50px;\n    margin-right: 50px;\n    height: 42px;\n    border-radius: 6px;\n    width: 300px;\nfont-weight: 500;\nmargin-bottom: 20px;\n\n}\n\n.LoginH1{\n    text-align: center;\n    margin: 25px 0px 50px 0px;\n    font-weight: 500;\n} \n.forgotpassword{\n    float: left;\n    margin-top: 5px;\n    \n}\n.ortag{\n    color: #D2D2D2;\n    margin-left: 139px;\n    margin-bottom: 30px;\n    /* margin-top: 80px; */\n\n }\n.SubmitButton{\n    margin-Top: 50px;\n    margin-right: 58px;\n}\n.loginImage {\n    width: auto;\n    height: 62px;\n}\n.LogoDiv{\n    display: flex;\n    justify-content: center;\n}\n.otpInput{\n    margin-top: 30px;\n}\n.logindiv1{\n    margin: 0 auto;\n    margin-top: 30vh;\n}\n.otpInput .otpBoxInput input{\n    width: 50px !important;\n    height: 50px;\n    font-size: 20px;\n    border-radius: 8px;\n    border: 1px solid #CDCDCD;\n    margin-right: 10px;\n    \n    \n}\n.otpInput{\n    width: 200px !important;\n}\n.otpInput .otpBoxInput input:first-child {\n    margin-left: 20px; /* Adjust the value as needed */\n}\n\n.otpInput .otpBoxInput input:last-child {\n    margin-right: 0;\n}\n.ForgotpassRow{\n    justify-content: center;\n}\n.Btncls{\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
